import { useOrgFeature } from "@/src/services/organization/org-features.hooks";
import { useGetCalendarEventsQuery } from "@/src/services/api/events/events.hooks";
import { router } from "expo-router";
import { ScrollView, View } from "react-native";
import EventsNextUp from "../../events/right-panel/event-next";
import { LeaderboardWidget } from "./leaderboard-widget";
import { TrendingTagsWidget } from "./trending-tags-widget";
// import { UpcomingBirthdaysWidget } from "./upcoming-birthdays-widget";

type RightPanelProps = Readonly<{
  selectedTag?: string | null;
  onTagSelect?: (tag: string | null) => void;
  onLeaderboardSeeAll?: () => void;
}>;

export const RightPanel = ({
  selectedTag,
  onTagSelect,
  onLeaderboardSeeAll,
}: RightPanelProps) => {
  const { data: calendarEvents } = useGetCalendarEventsQuery({
    where: {},
    order: [{ field: "startTime", direction: "ASC" }],
    pageNo: 1,
    pageSize: 100,
  });
  const { enabled: leaderboardEnabled } = useOrgFeature("leaderboard");
  const { enabled: eventsEnabled } = useOrgFeature("events");

  return (
    <ScrollView
      className="hidden md:flex md:w-[26%]"
      showsVerticalScrollIndicator={false}
      contentContainerClassName="pb-6"
    >
      <View className="gap-4">
        {leaderboardEnabled && (
          <LeaderboardWidget onSeeAll={onLeaderboardSeeAll} />
        )}
        {/* <TrendingTagsWidget */}
        {/*   selectedTag={selectedTag} */}
        {/*   onTagSelect={onTagSelect} */}
        {/* /> */}
        {eventsEnabled && (
          <EventsNextUp
            events={calendarEvents?.items ?? []}
            onSeeAll={() => router.push("/events")}
            onEventPress={(event) => router.push(`/events/${event.ItemId}`)}
          />
        )}
        {/* <UpcomingBirthdaysWidget /> */}
      </View>
    </ScrollView>
  );
};

export default RightPanel;
